<template>
  <div v-if="!sent">
    <FormulateForm
      name="resetPassword"
      v-model="formValues"
      @submit="resetPassword"
      class="mb-6"
    >
      <h1 class="font-bold text-3xl mb-8">
        Reset password
      </h1>

      <FormulateInput
        name="new_password1"
        type="password"
        label="New password"
        placeholder="Password"
        validation="bail|required|min:8,length"
        validation-name="Password"
      />
      <FormulateInput
        name="new_password2"
        type="password"
        label="Confirm new password"
        placeholder="Confirm password"
        validation="bail|required|confirm:new_password1"
        validation-name="Confirmation"
      />
      <FormulateErrors />
      <base-button type="submit" :loading="sending">
        Reset
      </base-button>
    </FormulateForm>

    <router-link
      to="/login"
      class="inline-block text-sm text-black border-b-2 border-transparent hover:border-blue-400"
    >
      Login
    </router-link>
  </div>
  <div v-else>
    <h1 class="text-green-400 font-bold text-3xl mb-4">
      Password changed!
    </h1>
    <p class="mb-4">
      You can now log in with your new password.
    </p>
    <router-link
      to="/login"
      class="inline-block mt-6 text-2xl text-black border-b-2 border-transparent hover:border-blue-400"
    >
      Log in
    </router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formValues: {},
      sending: false,
      sent: false,
    };
  },
  methods: {
    async resetPassword(data) {
      try {
        this.$formulate.resetValidation('resetPassword');
        this.sending = true;
        await this.$api.post('/rest-auth/password/reset/confirm/', {
          ...this.$route.params,
          ...data,
        });
        this.sent = true;
      } catch (error) {
        this.$formulate.handle(
          {
            ...error,
            customFormErrors: {
              uid: 'Token was already used or is invalid!',
              token: 'Token was already used or is invalid!',
            },
          },
          'resetPassword'
        );
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>
